import { Button } from '@material-ui/core';
import en from '../../../lang/en-us';
import { maskMobileNumber } from '../../../utils/utilityFunctions';
import SuccessScreen from '../makeNct/SuccessScreen';
const { dashboard } = en;

export default function UnregisteredFoliosSuccess(props: any) {
    const { mobile, reqId } = props.location.state || {};
    return (
        <div className="curved-bg">
            <SuccessScreen
                heading={dashboard.ChangeMobile.Success.back}
                backLink="nct"
                info1={dashboard.ChangeMobile.Success.subHeadingInfo1}
                infospan1={maskMobileNumber(mobile)}
                info2={dashboard.ChangeMobile.Success.subHeadingInfo2}
                infospan2={reqId}
                info3={dashboard.ChangeMobile.Success.subHeadingInfo3}
                // list={getList(data)}
                backNavigation={() => props.history.goBack()}
                handleClick={() => props.history.push('/portal/track')}
            />
        </div>
    );
}
